var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:[("cell-value-" + _vm.col), 'text-center']},[_c('font-awesome-icon',{attrs:{"icon":_vm.prepareIcon(_vm.entry[_vm.col])}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }